<template>
  <!-- EP签证信息 -->
  <div>
    <!-- 编辑模式：添加按钮 + 列表 -->
    <template v-if="!isReadonly">
      <div class="pb16">
        <!-- 只能添加一个 -->
        <el-button type="primary" plain icon="el-icon-circle-plus-outline" class="fs12" @click="addHandle" v-if="!innerValue || innerValue.length == 0">
          {{ $t("enroll.establish.addEPApplicant") }}
        </el-button>
      </div>

      <div v-if="innerValue.length != 0">
        <el-table :data="innerValue" border class="wdb100">
          <el-table-column prop="fullName" :label="$t('enroll.intitle.compellation')" align="center"></el-table-column>
          <el-table-column prop="nationality" :label="$t('enroll.questionnaire.countryOrNationality')" align="center"></el-table-column>
          <el-table-column prop="phone" :label="$t('enroll.intitle.phone')" align="center"></el-table-column>
          <el-table-column prop="email" :label="$t('enroll.intitle.email')" align="center"></el-table-column>
          <el-table-column :label="$t('common.operation')" align="center">
            <template>
              <el-button type="text" icon="el-icon-edit" class="mr6" @click="editHandle">{{ $t("common.button.edit") }}</el-button>
              <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle">{{ $t("common.button.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <p class="pt10 fs12 lh16 crgy919">
        {{ $t("enroll.intitle.suggest") }}
      </p>
    </template>

    <!-- 回显模式：直接平铺展示EP申请人详情 -->
    <template v-else>
      <div v-if="normalizedRow" class="viewCard">
        <ep-visa-form-panel :form="normalizedRow" :isReadonly="true"></ep-visa-form-panel>
      </div>
      <p class="pt10 fs12 lh16 crgy919">
        {{ $t("enroll.intitle.suggest") }}
      </p>
    </template>

    <!-- 新建/编辑 - 弹窗(编辑模式专用) -->
    <add-or-update v-if="!isReadonly" ref="addOrUpdateRef" @update="updateItem"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate.vue";
import EpVisaFormPanel from "./modal/EpVisaFormPanel.vue";
import { normalizeEpVisaForm } from "./modal/formFactory";

export default {
  name: "EpVisaInformation",
  components: { AddOrUpdate, EpVisaFormPanel },
  props: {
    /** v-model 绑定值：EP签证信息数组（最多一条） */
    value: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** 内部列表，与 value 保持同步 */
    innerValue: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    /** 回显模式：归一化后的 EP 申请人(补全缺失字段，最多一条) */
    normalizedRow() {
      const list = this.innerValue || [];
      return list.length > 0 ? normalizeEpVisaForm(list[0]) : null;
    },
  },
  methods: {
    // 添加EP申请人
    addHandle() {
      this.$refs.addOrUpdateRef.init(null);
    },
    // 编辑EP申请人
    editHandle() {
      const item = this.innerValue.length > 0 ? this.innerValue[0] : null;
      this.$refs.addOrUpdateRef.init(item);
    },
    // 删除EP申请人
    deleteHandle() {
      this.innerValue = [];
    },
    // 子组件触发更新（新增或编辑回调）
    updateItem(obj) {
      this.innerValue = [obj];
    },
  },
};
</script>

<style lang="scss" scoped>
/* 回显模式 - EP申请人详情卡片(无标题) */
.viewCard {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 0 20px 10px;
  margin-bottom: 20px;
}
</style>
